import React from "react";
import styles from './style.module.css'

const Wizard = props => {
  const {options, selected, className, ...other} = props;

  let optionsDOM = []
  options.forEach((o, index) => {
    optionsDOM.push(
      <button onClick={o.onClick} type="button" className={styles.option} wizard-status={selected == index+1 ? 'selected' : selected > index+1 ? 'completed' : 'waiting'}>
        <span className={styles.number}>{index+1}</span>
        <span className={styles.label}>{o.label}</span>  
      </button>
    )
  })
  return(
    <div className={`${styles.wizard} ${className ? className : ''}`}>
      {optionsDOM}
    </div>
  )
}

export default Wizard 